import { render, staticRenderFns } from "./StatusChart.vue?vue&type=template&id=b10a6340"
import script from "./StatusChart.vue?vue&type=script&lang=ts"
export * from "./StatusChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b10a6340')) {
      api.createRecord('b10a6340', component.options)
    } else {
      api.reload('b10a6340', component.options)
    }
    module.hot.accept("./StatusChart.vue?vue&type=template&id=b10a6340", function () {
      api.rerender('b10a6340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cards/StatusChart.vue"
export default component.exports